import Image from 'next/image';

import { SectionWrapper } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';

const WeBringYouBusiness = () => {
  return (
    <div
      className={`rounded-xl sm:rounded-2xl shadow-md p-5 sm:p-6 md:p-8 lg:p-10 xl:p-12 2xl:p-14 flex flex-col md:flex-row items-start gap-4 xs:gap-5 sm:gap-6 md:gap-8 lg:gap-10 xl:gap-12 2xl:gap-14 hover:shadow-lg transition-shadow duration-300 border border-pink-200`}
    >
      <div className='w-full md:w-2/5 lg:w-1/3 xl:w-1/3 2xl:w-1/5 flex-1 text-left self-center'>
        <div className='text-4xl xs:text-2xl sm:text-3xl md:text-4xl font-semibold leading-tight bg-brand-gradient bg-clip-text text-transparent'>
          We Bring You Business
        </div>
        <div className='mt-3 sm:mt-4 text-sm sm:text-base text-gray-600 leading-relaxed'>
          At Hafla, we don&apos;t just connect you to a platform — we connect
          you to results.
        </div>
      </div>
      <div
        className={`w-full md:w-3/5 lg:w-2/3 xl:w-2/3 2xl:w-4/5 flex flex-col sm:flex-row gap-4 xs:gap-5 sm:gap-6 md:gap-8 lg:gap-10 xl:gap-12 2xl:gap-14`}
      >
        <div className='flex-1'>
          <div className='text-lg sm:text-xl font-semibold text-gray-900'>
            Dedicated Growth Expert
          </div>
          <div className='text-xs sm:text-sm text-gray-600 mt-1 sm:mt-2'>
            Align, optimize & convert faster
          </div>
          <div className='mt-3 sm:mt-4 relative w-full aspect-square xs:aspect-[368/296] rounded-xl overflow-hidden'>
            <Image
              alt='Dedicated Growth Expert'
              className='object-cover'
              fill
              priority
              sizes='(max-width: 639px) 100vw, (max-width: 1023px) 50vw, 33vw'
              src={`${staticMediaStoreBaseURL}/landing-page/why-partner-with-hafla/growth-expert.png`}
            />
          </div>
        </div>
        <div className='flex-1'>
          <div className='text-lg sm:text-xl font-semibold text-gray-900'>
            Massive Customer Reach
          </div>
          <div className='text-xs sm:text-sm text-gray-600 mt-1 sm:mt-2'>
            Tap into UAE-wide bookings
          </div>
          <div className='mt-3 sm:mt-4 relative w-full aspect-square xs:aspect-[368/296] rounded-xl overflow-hidden'>
            <Image
              alt='Massive Customer Reach'
              className='object-cover'
              fill
              priority
              sizes='(max-width: 639px) 100vw, (max-width: 1023px) 50vw, 33vw'
              src={`${staticMediaStoreBaseURL}/landing-page/why-partner-with-hafla/customer-reach-v2.png`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const WhyPartnerWithHafla = () => {
  return (
    <SectionWrapper>
      <div className='max-w-4xl mx-auto text-center mb-10 sm:mb-12 md:mb-14 lg:mb-16'>
        <div className='text-2xl xs:text-3xl sm:text-4xl font-bold leading-tight text-stroke-thin md:text-stroke-normal'>
          Why Partner with{' '}
          <span className='bg-brand-gradient bg-clip-text text-transparent'>
            Hafla?
          </span>
        </div>
        <div className='mt-3 sm:mt-4 text-sm sm:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed'>
          Join the platform that&apos;s revolutionizing event planning with AI
          intelligence and human creativity.
        </div>
        <div className='flex justify-center mt-3 sm:mt-4 gap-2'>
          <div className='h-1 w-16 sm:w-20 bg-brand-gradient rounded-full' />
          <div className='h-1 w-4 sm:w-5 bg-brand-gradient rounded-full' />
        </div>
      </div>

      <div className='space-y-6 xs:space-y-8 sm:space-y-10 md:space-y-12 lg:space-y-14 xl:space-y-16 2xl:space-y-20'>
        <WeBringYouBusiness />
        <div className='grid gap-4 xs:gap-6 sm:gap-8 md:gap-10 lg:gap-12 xl:gap-14 2xl:gap-16 grid-cols-1 md:grid-cols-2'>
          <div
            className={`rounded-xl sm:rounded-2xl shadow-md p-5 sm:p-6 md:p-8 lg:p-10 flex flex-col md:flex-row items-center gap-4 sm:gap-5 md:gap-6 hover:shadow-lg transition-shadow duration-300 border border-pink-200`}
          >
            <div className='flex-1 text-left'>
              <div
                className={`text-4xl xs:text-2xl sm:text-3xl md:text-4xl font-semibold bg-brand-gradient bg-clip-text text-transparent leading-tight`}
              >
                We&apos;re with you at every step
              </div>
              <div className='mt-2 sm:mt-3 text-sm sm:text-base text-gray-600 leading-relaxed'>
                From setup to showtime, we&apos;ve got your back — with expert
                support and data-driven insights that help you deliver better
                and grow faster.
              </div>
            </div>
            <div
              className={`w-full max-w-[288px] h-[320px] xs:max-w-full xs:h-auto sm:max-w-[240px] sm:h-auto md:w-[200px] lg:w-[240px] xl:w-[280px] 2xl:w-[320px] flex-shrink-0 mt-4 md:mt-0 content-center`}
            >
              <Image
                alt='Every Step Support'
                className='rounded-lg object-cover xs:w-full xs:h-auto'
                height={284}
                sizes='(max-width: 639px) 100vw, (max-width: 1023px) 50vw, 25vw'
                src={`${staticMediaStoreBaseURL}/landing-page/why-partner-with-hafla/we-are-with-you.png`}
                width={256}
              />
            </div>
          </div>
          <div
            className={`rounded-xl sm:rounded-2xl shadow-md p-5 sm:p-6 md:p-8 lg:p-10 flex flex-col md:flex-row items-center gap-4 sm:gap-5 md:gap-6 hover:shadow-lg transition-shadow duration-300 border border-pink-200`}
          >
            <div className='flex-1 text-left'>
              <div
                className={`text-4xl xs:text-2xl sm:text-3xl md:text-4xl font-semibold bg-brand-gradient bg-clip-text text-transparent leading-tight`}
              >
                Hassle-Free Payouts. Always.
              </div>
              <div className='mt-2 sm:mt-3 text-sm sm:text-base text-gray-600 leading-relaxed'>
                Skip chasing multiple clients. Hafla pays you directly — on
                time, every time, and in the way you prefer. Reliable.
                Transparent. Hassle-free.
              </div>
            </div>
            <div
              className={`w-full max-w-[288px] h-[320px] xs:max-w-full xs:h-auto sm:max-w-[240px] sm:h-auto md:w-[200px] md:h-[222px] lg:w-[240px] lg:h-[266px] xl:w-[280px] xl:h-[310px] 2xl:w-[320px] 2xl:h-[355px] flex-shrink-0 mt-4 md:mt-0 content-center	`}
            >
              <Image
                alt='Hassle-Free Payouts'
                className='rounded-lg object-cover xs:w-full xs:h-auto'
                height={284}
                sizes='(max-width: 639px) 100vw, (max-width: 1023px) 50vw, 25vw'
                src={`${staticMediaStoreBaseURL}/landing-page/why-partner-with-hafla/hassle-free-payouts.png`}
                width={256}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default WhyPartnerWithHafla;
